import { useEffect } from 'react';
import { useAppSelector, useIsClientUser } from "app/hooks";
import { useNavigate } from 'react-router-dom';
import { getLocalStorageTokens, getLocalStoragePermissions } from 'utils/utilityFunctions';
import { setEmployeeProfileDetails } from 'app/slices/Employee/thunk';

const Home = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { accessToken, empName, empLoading } = useAppSelector(state => ({
    accessToken: state.auth.accessToken,
    empName: state.emp.name,
    empLoading: state.emp.empLoading,
  }));
  const isClientUser = useIsClientUser();

  useEffect(() => {    
    if (accessToken || getLocalStorageTokens()) {
      // // Check if user is a client user (check both Redux state and localStorage as fallback)
      // const permissions = getLocalStoragePermissions() || [];
      // const checkIsClientUser = isClientUser || permissions.some((perm: string) => 
      //   perm === 'client_management.view_my_client' || perm === 'client_management.view_my_clientuser'
      // );

      // Client users should go directly to the client portal and bypass employee bio-data
      if (isClientUser) {
        navigate('/client-portal', { replace: true });
        return;
      }

      setEmployeeProfileDetails();

      if (!empLoading) {
        if (empName) {
          navigate('/profile', { replace: true });
        } else {
          navigate('/bio-data', { replace: true });
        }
      }
    } else {
      navigate('/auth/sign-in', { replace: true });
    }
  }, [accessToken, empName, empLoading, isClientUser, navigate]);

  return null;
};

export default Home;
